import React from 'react'
import { css } from '@emotion/core'
import { LayoutBand, colors } from '@fs/zion-ui'
import { flavors, scrimGradient } from '../../config'

const gradientCss = css`
  background-position: right;
  background-size: 50%;
`

export default function RainbowBand({
  flavor = flavors.default,
  noScrim,
  opacity,
  children,
  maxWidth = 'lg',
  ...props
}) {
  const scrim = noScrim ? flavors.flavorless.filmedGradient : scrimGradient
  const gradient = flavors[flavor].gradient

  // NOTE: true transparency for the gradients requires modifying the colors in the strings themselves, so we mix the background color and create a fake transparency effect
  const transparencyOverlay = opacity
    ? `linear-gradient(90deg, color-mix(in srgb, ${colors.gray00} ${opacity * 100}%, transparent) 0%, color-mix(in srgb, ${colors.gray00} ${opacity * 100}%, transparent) 100%)`
    : null

  return (
    <LayoutBand
      maxWidth={maxWidth}
      css={gradientCss}
      style={{
        '--scrim': scrim,
        '--gradient': gradient,
        background: `${transparencyOverlay ?? ''}, ${scrim}, ${gradient}`,
      }}
      {...props}
    >
      {children}
    </LayoutBand>
  )
}
